// extracted by mini-css-extract-plugin
export default {"containerCard":"Card_containerCard__6wFmA","textoCard":"Card_textoCard__BTNGl","cardImg":"Card_cardImg__fitWx"};